import React from 'react'

interface NoDataProps {
    message?: any;
    isLoading?: boolean;
    style?: React.CSSProperties;
    imgStyle?: React.CSSProperties;
    textStyle?: React.CSSProperties;
    hideImage?: boolean
}

const NoData: React.FC<NoDataProps> = (props) => {
    return (
        <div className='row'>
            <div className='col-sm-12'>
                <div style={props?.style} className="no-results-to-show d-flex align-items-center justify-content-center">
                    <div className="center-part text-center">
                        {!props?.hideImage && <img src="/assets/images/no-results-to-show.png" alt="" style={{ maxWidth: "253px", width: "100%", ...props?.imgStyle }} />}
                        <h4 style={props?.textStyle}>{props?.isLoading ? "Loading..." : props?.message || 'No results to show'}</h4>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NoData